<div class="player-container">
  <video
    #videoElement
    controls
    autoplay
    style="width: 100%; height: auto;"
  >
    <source [src]="src" type="video/mp4" />
    Your browser does not support HTML5 video.
  </video>
</div>